module.exports = __webpack_public_path__ + "static/media/food_obsessions.78cbbcdd.png";